/**
 * Deterministic avatar styling for share comments (authorLabel + non-PII authorSeed).
 */

export function shareCommentAuthorInitial(authorLabel: string): string {
  const value = authorLabel.trim();
  const first = value[0];
  return first ? first.toUpperCase() : "?";
}

/** HSL background for a colored circle (readable on white canvas). */
export function shareCommentAvatarBackground(authorSeed: string): string {
  let h = 0;
  const s = authorSeed.trim().toLowerCase();
  for (let i = 0; i < s.length; i += 1) {
    h = s.charCodeAt(i) + ((h << 5) - h);
  }
  const hue = Math.abs(h) % 360;
  return `hsl(${hue} 52% 40%)`;
}
